class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = null;
    this.summaryToggle = null;
    this.closeButton = null;
    this.onBodyClickEvent = null;
  }

  connectedCallback() {
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('button[type="button"]');

    if (!this.detailsContainer || !this.summaryToggle || !this.closeButton) return;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer?.hasAttribute('open') ?? false;
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (!this.detailsContainer) return;
    this.detailsContainer.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    if (!this.detailsContainer) return;

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const focusableElement = this.detailsContainer.querySelector('[tabindex="-1"]');
    const inputElement = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (focusableElement && inputElement) {
      trapFocus(focusableElement, inputElement);
    }
  }

  close(focusToggle = true) {
    if (!this.detailsContainer || !this.summaryToggle) return;

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
